import {Component, DoCheck, ElementRef, Input, OnInit} from '@angular/core';
import {AbstractControl} from "@angular/forms";

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.css']
})
export class InputComponent implements OnInit, DoCheck {

  constructor(private elRef: ElementRef) {
  }

  @Input() formControlName: string;
  @Input() placeHolder: String;
  @Input() type: string = 'text';
  @Input() clazz: string;
  @Input() validate: boolean = false;
  @Input() name: string;
  @Input() control: AbstractControl;

  ngOnInit(): void {
  }

  ngDoCheck() {
    if (this.control.valid ) {
      this.elRef.nativeElement.child.findclassList.remove('has-error');
    } else {
      this.elRef.nativeElement.classList.add('has-error');
    }


  }

}
